import { render, staticRenderFns } from "./RegisterSuccessView.vue?vue&type=template&id=69b1b7de"
import script from "./RegisterSuccessView.vue?vue&type=script&lang=js"
export * from "./RegisterSuccessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports